import { MotionSpan, useInView, useMotionValue, useSpring, useTransform } from "@/lib/framer"
import { useEffect, useRef } from "react"

export function AnimatedNumber({ start, end, decimals = 0 }: { start: number; end: number; decimals?: number }) {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, amount: 0.5 })

  const value = useMotionValue(start)
  const spring = useSpring(value, { damping: 30, stiffness: 100 })
  const display = useTransform(spring, (num) =>
    Intl.NumberFormat("en-US", { maximumFractionDigits: decimals }).format(num),
  )

  useEffect(() => {
    value.set(isInView ? end : start)
  }, [start, end, isInView, value])

  return <MotionSpan ref={ref}>{display}</MotionSpan>
}
